import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as criteria from '../criteria'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: criteria.RESOURCE.payload.dimension.partialId,
      partialId: criteria.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The approach score for a criteria',
    isOptional: true,
    name: 'Approach Score',
    partialId: PartialId.Standard.create('approach_score'),
    type: core.common.value.types.Intrinsic.Decimal,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
